import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    standalone: true,
    imports: [TranslateModule, FormsModule]
})
export class ForgotPasswordComponent {
  modalRef!: MatDialogRef<any>;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  msg: string = "";
  showPassword: boolean = false;
  showForgotPasswordForm: boolean = false;
  otpSent: boolean = false;
  userEmail: string = '';
  otp: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  email: string;
  private baseUrl: any = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog
  ) { }


  backtoLogin() {
    this.router.navigate(['/login']);
  }

  // Simulate sending OTP to the email
  sendOtp() {
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.userEmail)) {
      this.email = this.userEmail;
      let data = {
        'email': this.userEmail
      };
      this.http.post(`${this.baseUrl}` + '/api/v1/users/reSetPasswordRequst', data).subscribe((response: any) => {
        if (response.success) {
          this.msg = "OTP has been sent to the given email!";
          this.openAlertMod(this.alertTemplate, this.msg);
          // alert('OTP has been sent to the given email!');
          this.otpSent = true;
        } else {
          this.msg = response.message;
          this.openAlertMod(this.alertTemplate, this.msg);
          // alert(response.message);
        }
      })
    } else {
      this.msg = "Please enter a valid email!";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Please enter a valid email');
    }
  }

  // Handle password reset logic
  resetPassword() {
    if (this.otp && this.newPassword === this.confirmPassword) {
      let data = {
        'email': this.email,
        'otp': this.otp,
        'newPassword': this.newPassword
      }
      this.http.post(`${this.baseUrl}` + '/api/v1/users/reSetPassword', data).subscribe((response: any) => {
        this.msg = "Your password has been changed!";
        this.openAlertMod(this.alertTemplate, this.msg);
        // alert('Your password has been changed!')
       setTimeout(() => {
        this.resetForm();
        this.router.navigate(['/login']);
      }, 2000); 
    });
    } else {
      this.msg = "Please check your OTP or passwords.";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Please check your OTP or passwords.');
    }
  }

  // Reset form after successful password reset or cancellation
  resetForm() {
    this.showForgotPasswordForm = false;
    this.otpSent = false;
    this.userEmail = '';
    this.otp = '';
    this.newPassword = '';
    this.confirmPassword = '';
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }
}
